import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/shared";
import { AttributionCard } from "@/components/dashboard/AttributionCard";
import { CurrencyPanels } from "@/components/dashboard/CurrencyPanels";
import { SummaryCards } from "@/components/dashboard/SummaryCards";
import { NeedsAttention } from "@/components/dashboard/NeedsAttention";
import { FollowUps } from "@/components/dashboard/FollowUps";
import { useAuth } from "@/context/AuthContext";

export default function Dashboard() {
  const { user } = useAuth();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/dashboard").then((r) => setD(r.data)); }, []);
  useEffect(() => { if (!d) return; const y = sessionStorage.getItem("dash-scroll"); if (y) { sessionStorage.removeItem("dash-scroll"); requestAnimationFrame(() => window.scrollTo(0, Number(y))); } }, [d]);
  if (!d) return <div className="text-sm text-slate-500">Loading dashboard…</div>;
  const f = d.financials;
  return (
    <div data-testid="dashboard-page" className="space-y-5">
      <PageHeader title="Dashboard" subtitle={`${d.counts.total} projects · ${user?.role === "team" ? "delivery view" : "amounts shown per currency, never added across currencies"}`} />
      {f && <CurrencyPanels rows={d.currency_summary} />}
      <SummaryCards d={d} />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 items-start">
        <div className="lg:col-span-2"><NeedsAttention items={d.attention} today={d.today} /></div>
        <FollowUps items={d.follow_ups} today={d.today} />
      </div>
      <AttributionCard attribution={d.attribution} canFin={!!f} />
    </div>
  );
}
